// extracted by mini-css-extract-plugin
export default {"unlockButton":"pDY7j","icon":"bSXDq","fanIcon":"KbMLg","unlockAvailable":"UH7Xy","big":"b5xjX","showAnimation":"DN_Rt","padding":"eDuON","span":"gbPVu"};